import { render } from "./dialog.md?vue&type=template&id=2c165870"
import script from "./dialog.md?vue&type=script&lang=js"
export * from "./dialog.md?vue&type=script&lang=js"
script.render = render

export default script